import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Users, Baby, GraduationCap, ArrowLeft } from 'lucide-react';

const RoleSelection = () => {
  const navigate = useNavigate();

  const roles = [
    {
      id: 'child',
      label: 'I\'m a Child',
      icon: Baby,
      color: 'from-pink-400 to-rose-400',
      description: 'Play games and learn!',
      route: '/profile-selection'
    },
    {
      id: 'parent',
      label: 'I\'m a Parent',
      icon: Users,
      color: 'from-blue-400 to-cyan-400',
      description: 'Monitor your child\'s progress',
      route: '/parent-setup'
    },
    {
      id: 'teacher',
      label: 'I\'m a Teacher',
      icon: GraduationCap,
      color: 'from-green-400 to-emerald-400',
      description: 'Track your students\' learning',
      route: '/teacher-setup'
    }
  ];

  return (
    <div className="min-h-screen p-4 md:p-8" style={{
      background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)'
    }}>
      <div className="max-w-6xl mx-auto">
        <Button
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-6 text-lg font-semibold text-white hover:scale-110 transition-transform"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back
        </Button>

        <div className="text-center mb-12 bounce-in">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4" style={{
            textShadow: '4px 4px 8px rgba(0,0,0,0.3)'
          }}>
            Who Are You?
          </h1>
          <p className="text-2xl text-white opacity-90">Select your role to continue</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {roles.map((role, index) => {
            const IconComponent = role.icon;
            return (
              <Card
                key={role.id}
                className="cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-2xl overflow-hidden slide-up"
                style={{
                  animationDelay: `${index * 0.1}s`,
                  borderRadius: '28px'
                }}
                onClick={() => navigate(role.route)}
              >
                <div className={`h-48 bg-gradient-to-br ${role.color} flex items-center justify-center relative overflow-hidden`}>
                  <div className="absolute inset-0 opacity-20">
                    <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-16 -translate-y-16"></div>
                    <div className="absolute bottom-0 right-0 w-24 h-24 bg-white rounded-full translate-x-12 translate-y-12"></div>
                  </div>
                  <IconComponent className="w-24 h-24 text-white float-animation" />
                </div>
                <div className="p-6 bg-white">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">{role.label}</h3>
                  <p className="text-gray-600 mb-4">{role.description}</p>
                  <Button
                    className="w-full py-5 text-lg font-bold transition-all duration-300"
                    style={{
                      background: `linear-gradient(135deg, ${role.color.replace('from-', '').replace(' to-', ', ')})`,
                      borderRadius: '14px'
                    }}
                  >
                    Continue as {role.label.replace("I'm a ", "")}
                  </Button>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RoleSelection;
